<template>
	<div class="container">
		<div class="BedInformation" :id="BedInformation">
			<div class="BedInformation_box">
				<div class="BedInformation_title">
					<div class="BedInformation_title_">
						<div class="BedInformation_button" v-if="BedInformation">
							<a-range-picker class="timeChange1" format="YYYY-MM-DD" :disabled-date="disabledDate"
								:default-value="[
									new Date()
										.toLocaleDateString()
										.replace('/', '-')
										.replace('/', '-'),
									new Date()
										.toLocaleDateString()
										.replace('/', '-')
										.replace('/', '-'),
								]" :placeholder="['开始时间', '结束时间']" @openChange="onOpenChange" @calendarChange="onCalendarChange"
								@change="onChangeTimer" inputReadOnly>
								<a-icon type="calendar" slot="suffixIcon" />
							</a-range-picker>
						</div>
					</div>
				</div>
				<div style="font-size: 18px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #262626; line-height: 24px; margin-top: 10px;">历史信息</div>
				<a-spin :spinning="spinning" tip="加载中" :delay="100" style="margin-top: -5px; flex: 1;">
					<div class="wirgin" v-if="!this.SocketBedInformation.length > 0">
						{{ bedInfo }}
					</div>
					<div class="BedInformation_contont" v-else :id="BedInformation ? 'BedInformation_contonts' : ''">
						<div class="BedInformation_contont_text" v-for="(item, index) in SocketBedInformation"
							v-show="item.content !== '用户状态变化为离床'" :key="index">
							<span :class="false ? 'red' : ''">{{
								item.time
							}}</span>
							<span :class="item.isStress == 1 ? 'red' : ''" :style="{
								display: item.content ? 'inline-block' : 'none',
							}">{{ item.content ? item.content : "" }}</span>
						</div>
					</div>
				</a-spin>
				<div class="pagesType" v-if="bedInfo != '暂无历史信息'">
					<a-pagination :defaultPageSize="12" :current="pageNum" :default-current="pageNum" :total="total == 0 ? 1 : total"
					@change="onShowSizeChange" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>

const defaultCheckedList = [];
const defaultCheckedList1 = [];
import moment from "moment";
import "moment/locale/zh-cn";

export default {
	props: {
		detailPageData: {
			type: Object,
			default: () => { },
		},
		bedId: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			moment,
			BedInformation: "BedInformations",
			SocketBedInformation: [], //最新消息床位
			checkedListType: true,
			checkedListType1: true,
			buttonTextType: true,
			buttonTextType1: true,
			checkedListTex: "",
			checkedListTex1: "",
			checkedList1: defaultCheckedList1,
			nullFunmsg: false,
			nullFunmsg1: false,
			indeterminate1: true,
			indeterminate: true,
			checkAll1: true,
			checkAll: true,
			plainOptions1: [],
			checkedList: defaultCheckedList,
			plainOptions: [],
			dateString: [], //选择时间
			pageNum: 1, // 当前页
			total: 1,
			jiluZT: [],
			jiluZT1: [],
			disabledCurrent: null, //禁用时间的变量
			spinning: true,
			bedInfo: "",
		};
	},
	created() {

	},
	mounted() {
		this.checkedList = [];
		this.checkedList1 = [];
		this.getEventFilterOption();
		let time = new Date()
			.toLocaleDateString()
			.replace("/", "-")
			.replace("/", "-");
		this.dateString.push(time, time);
		console.log(this.dateString[0].split("-"), "this.dateString");
		setTimeout(() => {
			this.getbedChoice();
		}, 2000);
	},
	methods: {
		/**
		 * 清空禁用时间段的设置
		 */
		onOpenChange(status) {
			// 清空禁用时间段的设置
			this.disabledCurrent = null;
		},
		/**
		 * 获取手动选择的时间段起始值
		 */
		onCalendarChange(dates) {
			console.log("From: ", dates[0], ", to: ", dates[1]);
			// 获取手动选择的时间段起始值
			this.disabledCurrent = dates[0];
		},
		/**
		 * 时间控制切换赋值
		 */
		onChangeTimer(moment, data) {
			//this.fromTime = data[0];
			//this.toTime = data[1];
			this.dateString = data;
			this.pageNum = 1;
			this.getbedChoice();
		},
		/**
		 * 1、时间限制范围 开始时间~结束时间不能超过31天
		 */
		disabledDate(current) {
			if (!this.disabledCurrent) return current > moment().startOf(1, "day");

			return (
				(current && current > moment().startOf(1, "day")) ||
				current <
				moment(this.disabledCurrent).subtract(1, "M").startOf("day") ||
				current > moment(this.disabledCurrent).add(1, "M").endOf("day")
			);
		},
		//选择床位确定事件
		bedChoice() {
			if (this.dateString.length < 1) {
				this.$message.error("请选择时间范围！！！");
				return;
			}
			this.nullFunmsg1 = false;
			let text = [];
			if (this.plainOptions1 && this.plainOptions1.length > 1) {
				this.plainOptions1.forEach((item) => {
					this.checkedList1.forEach((i) => {
						if (item.bedId == i) {
							text.push(item.bedName);
						}
					});
				});
				this.checkedListTex1 = JSON.stringify(text).split("[")[1].split("]")[0];
			} else if (this.plainOptions1 && this.plainOptions1.length == 1) {
				this.checkedListTex1 = this.plainOptions1[0].bedName;
			}
			if (this.checkedList1.length == this.plainOptions1.length) {
				this.buttonTextType1 = true;
				this.checkedListType1 = true;
			} else if (this.checkedList1.length == 0) {
				this.buttonTextType1 = false;
				this.checkedListType1 = true;
			} else if (
				this.checkedList1.length > 1 &&
				this.checkedList1.length != this.plainOptions1.length
			) {
				this.checkedListType1 = false;
			}
			this.jiluZT1 = JSON.parse(JSON.stringify(this.checkedList1));
			this.getbedChoice();
		},
		//取消选择床位
		bedChoiceErr() {
			this.checkedList1 = this.jiluZT1;
			this.nullFunmsg1 = false;
		},
		//清空事件
		getNull1() {
			this.checkedList1 = [];
		},
		//选择床位或选择类型之后请求接口
		getbedChoice() {
			if (this.dateString.length < 1 || this.dateString[0] == "") {
				this.$message.error("请选择时间范围！！！");
				return;
			}
			this.spinning = true;
			let bedIds = "";
			if (this.checkedList1.length == this.plainOptions1.length) {
				bedIds = "";
			} else if (
				this.checkedList1.length > 0 &&
				this.checkedList1.length != this.plainOptions1.length
			) {
				bedIds = JSON.stringify(this.checkedList1).split("[")[1].split("]")[0];
			} else if (this.checkedList1.length == 0) {
				bedIds = 0;
			}
			let a = null;
			if (this.dateString[0].split("-")[1].length < 2) {
				a = "0" + this.dateString[0].split("-")[1];
			} else {
				a = this.dateString[0].split("-")[1];
			}
			let b = null;
			if (this.dateString[0].split("-")[2].length < 2) {
				b = "0" + this.dateString[0].split("-")[2];
			} else {
				b = this.dateString[0].split("-")[2];
			}
			let a1 = null;
			if (this.dateString[1].split("-")[1].length < 2) {
				a1 = "0" + this.dateString[1].split("-")[1];
			} else {
				a1 = this.dateString[1].split("-")[1];
			}
			let b1 = null;
			if (this.dateString[1].split("-")[2].length < 2) {
				b1 = "0" + this.dateString[1].split("-")[2];
			} else {
				b1 = this.dateString[1].split("-")[2];
			}
			let endDate = this.dateString[1].split("-")[0] + "-" + a1 + "-" + b1; //结束时间
			let pageNum = this.pageNum;
			let pageSize = 12;
			let startDate = this.dateString[0].split("-")[0] + "-" + a + "-" + b; //开始时间
			let typeIds = "";
			if (this.checkedList.length == this.plainOptions.length) {
				typeIds = "";
			} else if (
				this.checkedList.length > 0 &&
				this.checkedList.length != this.plainOptions.length
			) {
				typeIds = JSON.stringify(this.checkedList).split("[")[1].split("]")[0];
			} else if (this.checkedList.length == 0) {
				typeIds = 0;
			}

			this.$get(
				"/api/sos/sosEventLogPage?bedId=" +
				this.bedId +
				"&onlyBed=1" +
				"&endDate=" +
				endDate +
				"&startDate=" +
				startDate +
				"&pageNum=" +
				pageNum +
				"&pageSize=" +
				pageSize +
				"&typeIds=" +
				typeIds,
				"",
				(res) => {
					this.spinning = false;
					this.total = res.data.sosEventLogVoPage.total;
					if (res.data.sosEventLogVoPage.records && res.data.sosEventLogVoPage.records.length > 0) {
						this.SocketBedInformation = res.data.sosEventLogVoPage.records;
						this.bedInfo = "";
					} else {
						this.SocketBedInformation = [];
						this.bedInfo = "暂无历史信息";
					}
					console.log(res, "ccccccccc");
				},
				(err) => {
					this.spinning = false;
					this.bedInfo = "";
					console.log(err);
				}
			);
		},
		onChanges1(checkedList) {
			this.indeterminate1 =
				!!checkedList.length && checkedList.length < this.plainOptions1.length;
			this.checkAll1 = checkedList.length === this.plainOptions1.length;
		},
		//获取事件类型
		getEventFilterOption() {
			this.$get(
				"/api/event/eventFilterOption?onlyBed=1",
				{},
				(res) => {
					if (!res.data) {
						return;
					}
					this.plainOptions = res.data;
					//事件类型默认全选
					res.data.forEach((item) => {
						this.checkedList.push(item.key);
					});
					this.jiluZT = JSON.parse(JSON.stringify(this.checkedList));
				},
				(err) => {
					console.log(err);
				}
			);
		},
		//取消选择类型
		typeChoiceErr() {
			this.checkedList = this.jiluZT;
			this.nullFunmsg = false;
		},
		//选择类型
		typeChoice() {
			if (this.dateString && this.dateString.length < 1) {
				this.$message.error("请选择时间范围！！！");
				return;
			}
			this.nullFunmsg = false;
			let text = [];
			if (this.plainOptions && this.plainOptions.length > 1) {
				this.plainOptions.forEach((item) => {
					this.checkedList.forEach((i) => {
						if (item.key == i) {
							text.push(item.value);
						}
					});
				});
				this.checkedListTex = JSON.stringify(text).split("[")[1].split("]")[0];
			} else if (this.plainOptions && this.plainOptions.length == 1) {
				this.checkedListTex = this.plainOptions[0].bedName;
			}
			if (this.checkedList.length == this.plainOptions.length) {
				this.buttonTextType = true;
				this.checkedListType = true;
			} else if (this.checkedList.length == 0) {
				this.buttonTextType = false;
				this.checkedListType = true;
			} else if (
				this.checkedList.length >= 1 &&
				this.checkedList.length != this.plainOptions.length
			) {
				this.checkedListType = false;
			}
			this.jiluZT = JSON.parse(JSON.stringify(this.checkedList));
			this.pageNum = 1;
			this.getbedChoice();
		},
		//废弃的日期切换事件
		onChange(date, dateString) {
			let sDate1 = Date.parse(dateString[0]);
			let sDate2 = Date.parse(dateString[1]);
			let dateSpan = sDate2 - sDate1;
			dateSpan = Math.abs(dateSpan);
			let iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
			if (iDays > 31) {
				this.$message.error("所选时间间隔不得超过31天！！！");
				return false;
			}
			this.dateString = dateString;
			this.getbedChoice();
		},
		//事件选择
		nullFunClick() {
			if (
				event.target.className == "spannone" ||
				event.target.className == "spannone1" ||
				event.target.className == "firstSpan"
			) {
				this.nullFunmsg = this.nullFunmsg ? false : true;
				this.bedChoiceErr();
				if (this.jiluZT.length > 0) {
					this.indeterminate = true;
				} else {
					this.indeterminate = false;
				}
				if (this.jiluZT.length == this.plainOptions.length) {
					this.checkAll = true;
					this.indeterminate = false;
				} else {
					this.checkAll = false;
					this.indeterminate = false;
				}
				this.nullFunmsg1 = false;
				this.jiluZT = JSON.parse(JSON.stringify(this.checkedList));
			}
		},
		//清空事件
		getNull() {
			this.checkedList = [];
			this.checkAll = false;
		},
		onChanges(checkedList) {
			this.indeterminate =
				!!checkedList.length && checkedList.length < this.plainOptions.length;
			this.checkAll = checkedList.length === this.plainOptions.length;
		},
		onShowSizeChange(e) {
			this.pageNum = e;
			this.getbedChoice();
		},
	},
	beforeDestroy() {
	},
	watch: {},
};
</script>
<style lang="scss" scoped>
.container {
	height: 518px;
	background: #fff;
	display: flex;
	width: 100%;
	border-radius: 0 0 8px 8px;
}

.BedInformation {
	width: 100%;
	height: 100%;

	.pagesType {
		display: flex;
		justify-content: center;
		height: 52px;
	}

	.BedInformation_box {
		width: 100%;
		height: 100%;
		box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12) !important;
		border-radius: 8px;
		padding: 0px 20px 0px 20px !important;
		background: #ffffff;
		display: flex;
		flex-direction: column;

		.BedInformation_title {
			width: 100%;
			margin-left: -10px;
			margin-top: 20px;

			.BedInformation_title_ {
				display: flex;
				align-items: center;
				margin: auto;
			}

			.BedInformation_button {
				display: flex;
				align-items: center;

				.spannone {
					padding: 0 10px 0 10px;
					height: 32px;
					background: #e6f7ff;
					border-radius: 2px;
					line-height: 32px;
					text-align: center;
					font-size: 14px;
					font-weight: 400;
					color: #1890ff;
					margin-left: 10px;
					cursor: pointer;
					position: relative;

					#nb {
						span:first-child {
							width: 150px !important;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}

					.spannone1 {
						display: flex;

						span:first-child {
							width: 80px;
							text-align: left;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}

					.spannoneDiv {
						position: absolute;
						width: 176px;
						background: #ffffff;
						border-radius: 2px;
						border: 1px solid rgba(0, 0, 0, 0.15);
						overflow: auto;
						display: flex;
						flex-direction: column;
						align-items: flex-start;
						padding: 5px 12px 5px 12px;
						z-index: 10;

						.butt {
							width: 90%;
							position: absolute;
							bottom: 0;
							display: flex;
							align-items: flex-start;
							justify-content: flex-end;
							padding-bottom: 10px;

							button {
								margin-right: 10px;
							}
						}

						.ant-checkbox-wrapper {
							display: flex;
							align-items: center;
						}

						.ant-checkbox-group {
							display: flex;
							flex-direction: column;
							align-items: flex-start;
							width: 100%;
							padding-bottom: 60px;

							.ant-col {
								margin-top: 10px;
							}
						}
					}

					.spannoneDiv1 {
						position: absolute;
						width: 920px;
						height: 219px;
						background: #ffffff;
						border-radius: 2px;
						border: 1px solid rgba(0, 0, 0, 0.15);
						overflow: auto;
						display: flex;
						flex-direction: column;
						align-items: flex-start;
						padding: 5px 12px 5px 12px;

						.butt {
							width: 98%;
							position: absolute;
							bottom: 0;
							display: flex;
							align-items: flex-start;
							justify-content: flex-end;
							padding-bottom: 10px;

							button {
								margin-right: 10px;
							}
						}

						.ant-checkbox-wrapper {
							display: flex;
							align-items: center;
							justify-content: flex-start;
						}

						.ant-checkbox-group {
							display: flex;
							flex-wrap: wrap;
							align-items: flex-start;
							width: 100%;
							max-height: 250px;
							overflow: auto;

							.ant-col {
								margin-top: 10px;
							}
						}
					}
				}

				// .timeChange 
			}

			.looknone1 {
				font-size: 18px;
				font-weight: 500;
				color: #262626;
			}

			.looknone {
				font-size: 14px;
				font-weight: 400;
				color: #1890ff;
				margin-left: 10px;
				line-height: 24px;
				cursor: pointer;
			}
		}

		.wirgin {
			font-size: 14px;
			font-weight: 400;
			color: rgba(140, 140, 140, 1);
			height: 170px;
			text-align: center;
			display: flex;
			justify-content: center;
			align-items: flex-end;
		}

		.BedInformation_contont {
			width: 100%;
			padding-bottom: 10px;

			.BedInformation_contont_text {
				width: 100%;
				display: flex;
				margin-top: 8px;

				.red {
					color: red !important;
				}

				span {
					margin-left: 10px;
					font-size: 14px;
					font-weight: 400;
					color: #262626;
				}

				span:nth-child(2) {
					// width: 214px;
				}

				span:first-child {
					margin-left: 0;
					width: 190px;
				}
			}
		}
	}
}


</style>

<style>
.timeChange1 {
	width: 240px !important;
	height: 32px;
	margin-left: 10px;
	background: #e6f7ff !important;
	span,
	input,
	input::-webkit-input-placeholder,
	.ant-calendar-range-picker-input {
	color: #1890ff !important;
	background: #e6f7ff !important;
	border: none !important;
	}
}

</style>
